import * as React from 'react';
import { connect } from 'react-redux';
import { Action, ConfirmationDialog } from '../components';
import { EConfirmationOperationType, ComponentHelper, IComponent, IComponentIdHolder, EComponentTypes, IComponentDictionary, QueryBuilderHelper, EModalType, PropertyHelper, ActionHelper, IAction, clone, IProperty, IProcessState, getEntityOptionSetFromService, IControl, ISharedJourney, OutputsHelper, AdminToolHelper, AdminToolPanelHelper } from '../helpers';
import store from '../store/store';
import types from '../store/types';
import { Promise } from 'es6-promise';
import { JourneyEngineSettingsHelper } from '../helpers/journeyenginesettingshelper';

class ConfirmationDialogContainer extends React.Component<any, any> {

	deleteDecision = (decisionComponentId: string, closeModalAfterDeletion: boolean, inLoop: boolean): void => {
		let component: IComponent = this.props.components[decisionComponentId];
		let linkedComponents: string[] = ComponentHelper.getLinkedComponents(component.Id, component.NextComponent ? component.NextComponent.ComponentId : null, false);
		let nextComponent = component.NextComponent;

		for (let i = 0; i < linkedComponents.length; i++) {
			store.dispatch({ type: types.DELETE_COMPONENT, componentId: linkedComponents[i] });
		}

		if (!inLoop) {
			store.dispatch({ type: types.DELETE_ACTIVE_COMPONENT, componentId: this.props.state.componentId });

			store.dispatch({
				type: types.REPLACE_NEXT_COMPONENT,
				componentIdToReplace: this.props.state.componentId,
				newNextComponent: nextComponent || null
			});
		}

		if (closeModalAfterDeletion) {
			this.close();
		}

	}

	getProperties = (): any => {
		return {
			components: store.getState().processState.components,
			StartId: store.getState().parentComponentId ? store.getState().processState.StartId : store.getState().StartId,
			searchLocation: store.getState().searchState.searchLocation,
			preventBlur: store.getState().searchState.preventBlur
		};
	}


	toggleComponent = (componentId: string, modalStateComponentId: string, openModal: number, componentModal: number, previousOutputBlocks: string[], closeModalAfterDeletion: boolean,) => {

		// if (modalStateComponentId === componentId &&
		// 	openModal === componentModal) {
		// 	store.getState().modalState.actionConfig.componentId = '';
		// }
		// else {
		// 	let { components } = this.getProperties();

		// 	store.dispatch({
		// 		type: types.TOGGLE_DIALOG,
		// 		openModal: EModalType.ActionConfig,
		// 		componentId: componentId,
		// 		action: components[componentId].Action,
		// 		previousOutputBlocks: previousOutputBlocks || {},
		// 		parentLoopId: components[componentId].ParentLoopId
		// 	});

		// 	PropertyHelper.updatePropertyFilterState(ComponentHelper.getProperties(components[componentId]));

		// 	store.dispatch({
		// 		type: types.SET_PREVIOUS_OUTPUT_BLOCKS,
		// 		previousOutputBlocks: previousOutputBlocks
		// 	});
		// }

		if (closeModalAfterDeletion) {
			this.close();
		}
	}

	deleteJESetting = (panelName: string, journeyEngineSettingsId: string, closeModalAfterDeletion: boolean): void => {

		// Remove je setting
		JourneyEngineSettingsHelper.removeFromJESettingsList(panelName, journeyEngineSettingsId).then(() => {
		})

		var isJESettingsList: boolean = true;
		AdminToolHelper.getAdminToolList(panelName, isJESettingsList).then(() => {
			AdminToolPanelHelper.SetPanelIsLoading(panelName, false);
			AdminToolHelper.ClearProcessList();
		});

		if (closeModalAfterDeletion) {
			this.close();
		}


	}

	cascadeOutput = (componentId: string, action: IControl | IAction | ISharedJourney, parentLoopId: string, deletedOutputs: string[], closeModalAfterDeletion: boolean) => {

		// save the action
		store.dispatch({
			type: types.UPDATE_ACTION,
			componentId: componentId,
			action: action,
			parentLoopId: parentLoopId,
			deletedOutputs: deletedOutputs
		});

		OutputsHelper.syncOutputs(deletedOutputs);

		//close the modal
		store.dispatch({ type: types.TOGGLE_DIALOG, openModal: EModalType.None });

		if (closeModalAfterDeletion) {
			this.close();
		}

	}

	deleteDecisionBranch = (branchIndex: number, decisionComponentId: string, closeModalAfterDeletion?: boolean, inLoop?: boolean): void => {
		store.dispatch({
			type: types.DELETE_BRANCH,
			branchIndex: branchIndex,
			componentId: decisionComponentId
		});


		// Save the the deicison after deleting
		let state = store.getState().modalState.decisionConfig;


		if (QueryBuilderHelper.canSaveQueryEditor()) {

			let newStateBranchComponents = {};
			for (let i = 0; i < state.decision.Branches.length; i++) {
				if (state.decision.Branches[i].NextComponent && state.decision.Branches[i].NextComponent.ComponentId) {
					newStateBranchComponents[state.decision.Branches[i].NextComponent.ComponentId] = true;
				}
			}

			let components = store.getState().processState.components;

			let removedBranchComponents: string[] = components[state.componentId].Decision.Branches
				.filter(c => c.NextComponent && c.NextComponent.ComponentId && !(newStateBranchComponents[c.NextComponent.ComponentId]))
				.map(c => c.NextComponent.ComponentId);

			for (let i = 0; i < removedBranchComponents.length; i++) {

				store.dispatch({
					type: types.DELETE_COMPONENT_CHAIN,
					componentId: removedBranchComponents[i],
					components: components
				});

			}

			// Save the decision
			store.dispatch({
				type: types.UPDATE_DECISION,
				componentId: state.componentId,
				decision: state.decision
			});

			if (removedBranchComponents.length) {
				store.dispatch({
					type: types.SET_ACTIVE_COMPONENTS,
					components: store.getState().processState.components
				});
			}

			store.dispatch({ type: types.TOGGLE_DIALOG, openModal: EModalType.None });

		}
		else {
			QueryBuilderHelper.goToFirstQueryEditorError();
		}

		// Close dialog after save
		if (closeModalAfterDeletion) {
			this.close();
		}
	}

	changeEntity = (key: string, value: any, closeModalAfterDeletion?: boolean): void => {

		let previousLabel = PropertyHelper.getPropertyValue(this.props.actionState.action.Properties, 'Label');
		let action = PropertyHelper.updateProperty(this.props.actionState.action, key, value);
		PropertyHelper.resolveAdjustedFields(action.Properties, this.props.propertyFilters, key, value, true);

		if (action.OutputValues) {
			let primaryOutput = action.OutputValues[0];

			if (key === 'Label' && ActionHelper.shouldOverwriteOutputName(primaryOutput.Name, previousLabel)) {
				action.OutputValues[0].Name = value;
			}
		}

		// If the changed value comes from Entity Name field, fetch necessary fields for the selected entity name.
		// Store the fields in the state to update the values in the Fields Name dropdown.
		if (key === 'Entity Name') {
			this.loadEntityFields(value, this.props.actionState.componentId)
		}

		// Update state action along with fieldConfigs
		store.dispatch({
			type: types.UPDATE_ACTION_ENTITY_DIALOG,
			action: action
		});

		store.dispatch({
			type: types.SET_IS_FIELD_CHANGED,
			value: false
		});

		// Close dialog after save
		if (closeModalAfterDeletion) {
			this.close();
		}


	}

	loadEntityFields = (name: string, componentId: string): Promise<any> => {

		let promise = new Promise<IAction>((resolve, reject) => {
			if (this.props.entityFields && this.props.entityFields[name]) {
				resolve(clone(this.props.entityFields[name]));
			}
			else {
				return ActionHelper.loadEntityFields(name, componentId)
					.then(entityFields => {
						resolve(entityFields)
					});
			}
		});

		return promise;
	}


	deleteControl = (componentId: string, controlId: string, controlIndex: number, layoutPanelIndex: number, outputs: any, deletedOutputs?: string[], changeCurrentControlIndex?, closeModalAfterDeletion?: boolean, inLoop?: boolean): void => {

		store.dispatch({
			type: types.DELETE_CONTROL,
			componentId: componentId,
			controlIndex: controlIndex,
			layoutPanelIndex: layoutPanelIndex,
			outputs: outputs,
			controlId: controlId
		});

		if (deletedOutputs) {

			// cascade values in locations where the delete outputs are used
			OutputsHelper.syncOutputs(deletedOutputs);

		}
		// Alter the state to refresh the control-config component
		store.getState().modalState.controlConfig.controlIndex = null;

		// Close dialog after save
		if (closeModalAfterDeletion) {
			this.close();
		}

	}

	deleteLayoutPanel = (componentId: string, layoutPanelIndex: number, outputs: any, deletedOutputs?: string[], changeCurrentControlIndex?, closeModalAfterDeletion?: boolean, inLoop?: boolean): void => {

		store.dispatch({
			type: types.DELETE_LAYOUT_PANEL,
			componentId: componentId,
			layoutPanelIndex: layoutPanelIndex,
			outputs: outputs
		});

		if (deletedOutputs) {

			// cascade values in locations where the delete outputs are used
			OutputsHelper.syncOutputs(deletedOutputs);

		}
		// Alter the state to refresh the control-config component
		store.getState().modalState.controlConfig.controlIndex = null;

		// Close dialog after save
		if (closeModalAfterDeletion) {
			this.close();
		}

	}

	deleteComponent = (deletedComponentId: string, newNextComponent: IComponentIdHolder, deletedOutputs?: string[], closeModalAfterDeletion?: boolean,): void => {

		// let newNextComponent: IComponentIdHolder = components[componentId].NextComponent;
		store.dispatch({ type: types.REPLACE_NEXT_COMPONENT, componentIdToReplace: deletedComponentId, newNextComponent: newNextComponent });

		store.dispatch({ type: types.DELETE_COMPONENT, componentId: deletedComponentId });
		store.dispatch({ type: types.DELETE_ACTIVE_COMPONENT, componentId: deletedComponentId });


		OutputsHelper.syncOutputs(deletedOutputs);

		// Close dialog after save
		if (closeModalAfterDeletion) {
			this.close();
		}

	}

	deleteFirstLoopComponent = (componentId: string, firstLoopComponentId: string, deletedComponentId: string, deletedOutputs?: string[], closeModalAfterDeletion?: boolean): void => {

		// let newNextComponent: IComponentIdHolder = components[componentId].NextComponent;
		store.dispatch({
			type: types.SET_FIRST_LOOP_COMPONENT_ID,
			componentId: componentId,
			firstLoopComponentId: firstLoopComponentId
		});

		store.dispatch({ type: types.DELETE_COMPONENT, componentId: deletedComponentId });
		store.dispatch({ type: types.DELETE_ACTIVE_COMPONENT, componentId: deletedComponentId });

		OutputsHelper.syncOutputs(deletedOutputs);

		// Close dialog after save
		if (closeModalAfterDeletion) {
			this.close();
		}

	}

	deleteLoop = (loopComponentId: string, closeModalAfterDeletion: boolean, deletedOutputs?: string[],): void => {

		let components: IComponentDictionary = this.props.components;

		let loopComponent: IComponent = this.props.components[loopComponentId];
		let nextComponent = loopComponent.NextComponent;

		let component: IComponent = loopComponent.Loop.FirstLoopComponent && loopComponent.Loop.FirstLoopComponent.ComponentId ?
			this.props.components[loopComponent.Loop.FirstLoopComponent.ComponentId] : null;

		while (component) {

			switch (component.ComponentType.ComponentTypeId) {

				case EComponentTypes.loop:
					this.deleteLoop(component.Id, false);
					break;
				case EComponentTypes.decision:
					this.deleteDecision(component.Id, false, (!!loopComponentId));
					break;
				default:
					store.dispatch({ type: types.DELETE_COMPONENT, componentId: component.Id });
					break;

			}

			component = component.NextComponent && component.NextComponent.ComponentId ? this.props.components[component.NextComponent.ComponentId] : null;
		}

		store.dispatch({ type: types.DELETE_LOOP, componentId: loopComponentId });
		store.dispatch({ type: types.DELETE_LOOP_ACTIVE_COMPONENT, componentId: loopComponentId });
		store.dispatch({
			type: types.REPLACE_NEXT_COMPONENT,
			componentIdToReplace: loopComponentId,
			newNextComponent: nextComponent || null
		});
		store.dispatch({ type: types.DELETE_COMPONENT, componentId: loopComponentId });

		OutputsHelper.syncOutputs(deletedOutputs);

		if (closeModalAfterDeletion) {
			this.close();
		}

	}

	setToTriageJourney = (): void => {
		store.dispatch({
			type: types.UPDATE_IS_TRIAGE_JOURNEY,
			isTriageJourney: true
		});
		this.close();
	}

	setToPageJourney = (): void => {
		store.dispatch({
			type: types.UPDATE_IS_PAGE_JOURNEY,
			isPageJourney: true
		});
		this.close();
	}

	hideSteps = (): void => {
		store.dispatch({
			type: types.UPDATE_HIDE_STEPS,
			hideSteps: true
		});
		this.close();
	}

	uncheckTriageJourney = (): void => {
		store.dispatch({
			type: types.UPDATE_IS_TRIAGE_JOURNEY,
			isTriageJourney: false
		});
		this.close();
	}

	uncheckPageJourney = (): void => {
		store.dispatch({
			type: types.UPDATE_IS_PAGE_JOURNEY,
			isPageJourney: false
		});
		this.close();
	}

	uncheckHideSteps = (): void => {
		store.dispatch({
			type: types.UPDATE_HIDE_STEPS,
			hideSteps: false
		});
		this.close();
	}

	setRepalceGuids = (replaceGuids: boolean): void => {
		store.dispatch({
			type: types.UPDATE_REPLACE_GUIDS,
			replaceGuids: replaceGuids
		});
		this.close();
	}

	setSaveAndResume = (saveAndResume: boolean): void => {
		store.dispatch({
			type: types.UPDATE_SAVE_AND_RESUME,
			saveAndResume: saveAndResume
		});
		this.close();
	}

	setToSharedJourney = (): void => {
		store.dispatch({
			type: types.UPDATE_IS_SHARED_JOURNEY,
			isSharedJourney: true
		});
		//locate the Journey Information component, then remove the component and its outputs
		for (let componentId in this.props.components) {
			let component: IComponent = this.props.components[componentId];

			if (component && component.Action && component.Action.ActionType && component.Action.ActionType.NameType === 'Journey Information') {
				store.dispatch({
					type: types.DELETE_COMPONENT_OUTPUTS,
					componentId: componentId
				});
				let newNextComponent: IComponentIdHolder = component.NextComponent;
				store.dispatch({ type: types.REPLACE_NEXT_COMPONENT, componentIdToReplace: componentId, newNextComponent: newNextComponent });
				store.dispatch({ type: types.DELETE_COMPONENT, componentId: componentId });
				store.dispatch({ type: types.DELETE_ACTIVE_COMPONENT, componentId: componentId });
			}
			else {

				if (component.ComponentType.ComponentTypeId === EComponentTypes.action) {

					if (component.Action.OutputValues) {

						component.Action.OutputValues.forEach(o => {
							o.DisplayOnSummary = false;
						});

						store.dispatch({
							type: types.UPDATE_ACTION,
							componentId: component.Id,
							action: component.Action
						});

					}

				}
				else if (component.ComponentType.ComponentTypeId === EComponentTypes.block) {

					if (component.ControlBlock.Controls) {

						component.ControlBlock.Controls.forEach((c, i) => {

							if (c.OutputValues) {
								c.OutputValues.forEach(o => {
									o.DisplayOnSummary = false;
								});
							}

							store.dispatch({
								type: types.UPDATE_CONTROL,
								componentId: component.Id,
								controlIndex: i,
								control: c
							});

						});

					}
				}

			}
		}
		this.close();
	}

	onOKClick = (): void => {
		switch (this.props.state.operationType) {
			case EConfirmationOperationType.ToggleComponent:
				this.toggleComponent(this.props.state.componentId, this.props.state.modalStateComponentId, this.props.state.openModal, this.props.state.componentModal, this.props.state.previousOutputBlocks, true);
				break;
			case EConfirmationOperationType.DeleteJESetting:
				this.deleteJESetting(this.props.state.panelName, this.props.state.journeyEngineSettingsId, true);
				break;
			case EConfirmationOperationType.CascadeOutputValues:
				this.cascadeOutput(this.props.state.componentId, this.props.state.action, this.props.state.parentLoopId, this.props.state.deletedOutputs, true);
				break;
			case EConfirmationOperationType.DeleteDecisionBranch:
				this.deleteDecisionBranch(this.props.state.branchIndex, this.props.state.componentId, true);
				break;
			case EConfirmationOperationType.DeleteDecision:
				this.deleteDecision(this.props.state.componentId, true, false);
				break;
			case EConfirmationOperationType.DeleteControl:
				this.deleteControl(this.props.state.componentId, this.props.state.controlId, this.props.state.controlIndex, this.props.state.layoutPanelIndex, this.props.state.outputs, this.props.state.deletedOutputs, this.props.changeCurrentControlIndex, true, false);
				break;
			case EConfirmationOperationType.DeleteLayoutPanel:
				this.deleteLayoutPanel(this.props.state.componentId, this.props.state.layoutPanelIndex, this.props.state.outputs, this.props.state.deletedOutputs, this.props.changeCurrentControlIndex, true, false);
				break;
			case EConfirmationOperationType.SetSharedJourney:
				this.setToSharedJourney();
				break;
			case EConfirmationOperationType.SetTriageJourney:
				this.setToTriageJourney();
				break;
			case EConfirmationOperationType.SetPageJourney:
				this.setToPageJourney();
				break;
			case EConfirmationOperationType.SetHideSteps:
				this.hideSteps();
				break;
			case EConfirmationOperationType.uncheckTriageJourney:
				this.uncheckTriageJourney();
				break;
			case EConfirmationOperationType.uncheckPageJourney:
				this.uncheckPageJourney();
				break;
			case EConfirmationOperationType.uncheckHideSteps:
				this.uncheckHideSteps();
				break;
			case EConfirmationOperationType.setRepalceGuids:
				this.setRepalceGuids(this.props.state.replaceGuids);
				break;
			case EConfirmationOperationType.setSaveAndResume:
				this.setSaveAndResume(this.props.state.saveAndResume);
				break;
			case EConfirmationOperationType.DeleteLoop:
				this.deleteLoop(this.props.state.componentId, true, this.props.state.deletedOutputs);
				break;
			case EConfirmationOperationType.ChangeEntity:
				this.changeEntity(this.props.state.actionType, this.props.state.actionEntity, true);
				break;
			case EConfirmationOperationType.DeleteSharedJounrey:
				this.deleteComponent(this.props.state.deletedComponentId, this.props.state.newNextComponent, this.props.state.deletedOutputs, true);
				break;
			case EConfirmationOperationType.DeleteAction:
				this.deleteComponent(this.props.state.deletedComponentId, this.props.state.newNextComponent, this.props.state.deletedOutputs, true);
				break;
			case EConfirmationOperationType.DeleteSubmission:
				this.deleteComponent(this.props.state.deletedComponentId, this.props.state.newNextComponent, this.props.state.deletedOutputs, true);
				break;
			case EConfirmationOperationType.DeleteFirstLoopComponent:
				this.deleteFirstLoopComponent(this.props.state.componentId, this.props.state.firstLoopComponentId, this.props.state.deletedComponentId, this.props.state.deletedOutputs, true);
				break;
			default:
				break;
		}
	}

	onCancelClick = (): void => {
		this.close();
	}

	close = (): void => {
		store.dispatch({ type: types.TOGGLE_CONFIRMATION_DIALOG });
	}

	public render() {

		let { title, message, okButtonLabel, cancelButtonLabel, isOpen, isCancelButtonHidden } = this.props.state;

		return (
			<ConfirmationDialog
				onOKClick={this.onOKClick}
				onCancelClick={this.onCancelClick}
				title={title}
				message={message}
				isOpen={isOpen}
				okButtonLabel={okButtonLabel}
				cancelButtonLabel={cancelButtonLabel}
				isCancelButtonHidden={isCancelButtonHidden}
			/>
		);

	}

}

let mapStateToProps = (store) => {
	return {
		state: store.confirmationDialogState,
		components: store.processState.components,
		actionState: store.modalState.actionConfig,
		propertyFilters: store.propertyFilterState.propertyFilters,
		entityFields: store.modalState.actionConfig.entityFields,
	};
};

export default connect<any, any, any>(mapStateToProps)(ConfirmationDialogContainer);


// WEBPACK FOOTER //
// ./source/ts/containers/confirmation-dialog.tsx